export const tableCellSanitizer = (text: string | number | null | undefined, placeholder = '--') => {
    if (!text) {
        return placeholder
    }
    return text.toString()
}
